import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer} from '@angular/common';
import { PubNubAngular } from 'pubnub-angular2';
//import { EventInteraction } from '../dynamic/event.interaction.service';
import { APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class PubNubEngine {

private isClient: boolean
public messageNotifier : BehaviorSubject<object>;
public isLive: boolean = false;;

constructor(
    private pubnubService: PubNubAngular,
    //private interactions : EventInteraction,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(APP_SETTINGS) private settings: any
) {
    this.isClient = isPlatformBrowser(this.platformId);
    this.messageNotifier = new BehaviorSubject(null);
    if (this.isClient && this.settings.PUBNUB_ENABLED){
        this.pubnubService.init({
            subscribeKey: this.settings.PUBNUB_SUBSCRIPTION_KEY
        });
        this.pubnubService.subscribe({
            channels: this.settings.PUBNUB_SUBSCRIPTION_CHANNELS,
            withPresence: false,
            triggerEvents: true
        });
        const self = this;
        this.pubnubService.getMessage(this.settings.PUBNUB_SUBSCRIPTION_CHANNELS, function(msg) {
            //console.log(msg);
            self.messageNotifier.next({ key: msg.channel, received: { 
                    channel: msg.channel, 
                    message: msg.message,
                    publish_time: msg.timetoken
                } 
            });
        });
        this.pubnubService.history({ 
                    channel: this.settings.PUBNUB_SUBSCRIPTION_CHANNELS[0],
                     count: 1
                 }).then((response) => {
                     const msg = response.messages[0];
                     if (!msg) return;
                     
                     self.isLive = msg.entry.live;
                     self.messageNotifier.next({ key: msg.channel, received: { 
                        channel: this.settings.PUBNUB_SUBSCRIPTION_CHANNELS[0], 
                        message: msg.entry,
                        publish_time: msg.timetoken
                    } 
                });

        });
    }
 }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/notification/pubnub.engine.service.ts